/**
 * Полка отпустила вилку — обещание больше не кормит купон.
 *
 * Не путать со сменой кэфа: тик «живого» обещание переписывает.
 * «Убрать» снимает его совсем, иначе хвост 150 с снова жмёт ячейку.
 */

export const REVOKE = 'forq:revoke-promises';

export type Revoke = {
  channel: typeof REVOKE;
  urls: string[];
};

const HTTP = /^https?:\/\//i;

export function revokeEnvelope(urls: readonly string[]): Revoke {
  return {
    channel: REVOKE,
    urls: [...new Set(urls.filter((url) => HTTP.test(url)))].slice(0, 8),
  };
}

export function parseRevoke(data: unknown): string[] | null {
  if (typeof data !== 'object' || data === null) return null;
  const body = data as Record<string, unknown>;
  if (body.channel !== REVOKE) return null;
  if (!Array.isArray(body.urls)) return null;
  const urls = body.urls.filter((url): url is string => typeof url === 'string' && HTTP.test(url));
  return urls.length === 0 ? null : urls.slice(0, 8);
}
